<template>
    <modal size="xl" @close="$emit('close')" ref="modal" :is-closeable="isCloseable" :autoshow="true">
        <template v-slot:title>
            <span v-if="reimbursementType">Update Reimbursement Type: </span><span v-if="reimbursementType" class="text-thin text-nowrap">{{ reimbursementType.name }}</span>
            <span v-if="!reimbursementType">Add Reimbursement Type</span>
        </template>
        <slot>
            <form class="mui-form" @submit.prevent="onSubmit()">
                <div class="form-row">
                    <div class="col">
                        <form-input v-model="formData.name" :errors="errors.name" type="text" label="Name" />
                    </div>
                </div>

                <div class="form-row mb-2">
                    <div class="col">
                        <form-input
                            v-model="formData.allow_multiple_per_company"
                            :errors="errors.allow_multiple_per_company"
                            type="checkbox"
                            label="Allow Multiple Per Company"
                            helper-text="When enabled, a company may have more than one reimbursement of this type."
                        />
                    </div>
                </div>

                <p class="mt-4 mb-0">
                    <a href class="text-muted small" @click.prevent="extraOpen = !extraOpen">Danger: Developer Only</a>
                </p>

                <div class="form-row mt-2 mb-2" v-show="extraOpen">
                    <div class="col">
                        <label class="form-label">Fields to Customize</label>
                        <div v-for="option in fieldsToCustomizeOptions" :key="option.value" class="form-check">
                            <input
                                class="form-check-input"
                                type="checkbox"
                                :value="option.value"
                                :id="`ftc_${option.value}`"
                                v-model="formData.fields_to_customize"
                            />
                            <label class="form-check-label" :for="`ftc_${option.value}`">{{ option.label }}</label>
                        </div>
                        <div v-if="errors.fields_to_customize" class="invalid-feedback d-block">{{ errors.fields_to_customize }}</div>
                    </div>
                </div>
            </form>
        </slot>

        <template v-slot:footer>
            <form-errors :errors="formErrors"/>

            <button-row>
                <button type="button" class="btn btn-block btn-outline-primary" @click.prevent="close()">Cancel</button>
                <button type="button" class="btn btn-block btn-primary" @click.prevent="onSubmit()">Save</button>
            </button-row>
        </template>
    </modal>
</template>

<script>
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'

export default {
    props: ['reimbursementType', ],
    mixins: [FormMixin, ModalMixin, ],
    computed: {
        fieldsToCustomizeOptions() {
            return [
                {value: 'name', label: 'Name'},
            ]
        },
    },
    data() {
        return {
            formData: this.makeFormData(),
            extraOpen: false,
        }
    },
    methods: {
        makeFormData() {
            if (this.reimbursementType) {
                return {
                    name: this.reimbursementType.name,
                    allow_multiple_per_company: this.reimbursementType.allow_multiple_per_company,
                    fields_to_customize: this.reimbursementType.fields_to_customize || [],
                }
            } else {
                return {
                    name: '',
                    allow_multiple_per_company: false,
                    fields_to_customize: [],
                }
            }
        },
        getFormData() {
            return this.formData
        },
        onSubmit() {
            if (!this.validate()) {
                return
            }

            let promise
            if (this.reimbursementType) {
                promise = this.$api.put(`/admin/tax-engine/reimbursement-types/${this.reimbursementType.id}`, this.getFormData())
            }
            else {
                promise = this.$api.post(`/admin/tax-engine/reimbursement-types`, this.getFormData())
            }

            this.$store.dispatch('START_LOADING')
            return promise.then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$emit('updated', resp)
                this.close()
            }).catch(errors => {
                this.$store.dispatch('STOP_LOADING')
                this.errors = errors
                this.formErrors = errors.__all__
                this.onError()
            })
        },
    }
}
</script>
